// @flow

export { DisplayArgentineIGIBP } from './display-argentine-ig-ibp';
